import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import * as Scroll from 'react-scroll';

let ScrollLink = Scroll.Link;

const Container = styled.div`
  position: fixed;
  top:10px;
  right:20px;
  border-radius: 13px;
  background: #080B31;
  padding: 30px;
  padding-bottom: ${props => props.sideState ? '50px' : '0px'};;
  padding-right: ${props => props.sideState ? '50px' : '0px'};;
  opacity: ${props => props.sideState ? "1" : "0"};
  z-index: 50;
  /* z-index: ${props => props.sideState ? "100" : "0"}; */
  visibility: ${props => props.sideState ? "visible" : "hidden"};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  transition-property: all;
  transition-duration: 0.3s, 0.3s, 0.3s, 0.3s, 0.3s;

  @media (min-width: 920px) {
    display: none;
  };
`
const SideMenuBox = styled.div`
  margin-top: 30px;
  padding-right: 50px;

  & > a {
    color: black;
    font-weight: 300;
    cursor: pointer;
    font-size: 13px;
    display: flex;
    align-items: center;

   & > a > p {
     margin-left: 15px;
     line-height: 360%;
     color: #fff;
     font-size: 15px;
     font-weight: bold;
   }
  }

  & > .active {
    font-weight: 500;
  }
`
const CloseButton = styled.div`
  cursor: pointer;
`
const Icon = styled.div`
 width: 24px;
 display: flex;
 justify-content: center;
 align-items: center;
 padding-bottom: 2px;
`
const SideBar = ({ sideState, closeOnPress, menuState }) => {

  return (
    <Container sideState={sideState}>
      {/* <CloseButton onClick={closeOnPress}>
        <svg width="15" height="15" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8501 2.94967C10.1165 0.215997 5.68431 0.215996 2.95064 2.94967C0.216973 5.68334 0.216973 10.1155 2.95064 12.8492L43.1512 53.0497L3.05025 93.1507C0.316582 95.8843 0.316582 100.317 3.05025 103.05C5.78392 105.784 10.2161 105.784 12.9497 103.05L53.0507 62.9492L93.0511 102.95C95.7848 105.683 100.217 105.683 102.951 102.95C105.684 100.216 105.684 95.7838 102.951 93.0502L62.9502 53.0497L103.05 12.9497C105.784 10.216 105.784 5.78384 103.05 3.05017C100.317 0.3165 95.8844 0.316498 93.1508 3.05017L53.0507 43.1502L12.8501 2.94967Z" fill="#8B98A8" />
        </svg>
      </CloseButton> */}
      <SideMenuBox>
        {
          menuState.map((item) => {
            return (
              <ScrollLink
                activeClass="active"
                to={item.text}
                spy={true}
                smooth={true}
                offset={-60}
                duration={500}
              >
                <Icon>
                  <img alt='' src={item.icon}/>
                </Icon>
                <Link to="/">
                  <p>{item.text}</p>
                </Link>
              </ScrollLink>
            )
          })
        }
      </SideMenuBox>
    </Container>
  );
};

export default SideBar; 